/* eslint-disable */
import { useEffect } from 'react';
var useLifecycles = function (mount, unmount) {
    useEffect(function () {
        if (mount) {
            mount();
        }
        return function () {
            if (unmount) {
                unmount();
            }
        };
    }, []);
};
export default useLifecycles;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useLifecycles.js
// module id = SUZR
// module chunks = 0